import { makeNumberRenderer } from 'App/data-export/valueTypeRenderers/renderers/_utils/makeNumberRenderer'
import type { valueTypeRenderers } from 'App/data-export/valueTypeRenderers/valueTypeRenderers'
import { translate } from 'i18n/i18n'
import { unitConverter } from 'utils/unitConverter/unitConverter'

export const alternariaCumulativeRolling7Days: typeof valueTypeRenderers.alternariaCumulativeRolling7Days = {
  label: () =>
    translate.phrases.templates('{{labelA}} ({{labelB}})', {
      labelA: translate.phrases.banyanApp('Alternaria'),
      labelB: translate.phrases.banyanApp('7 Day DSV'),
    }),
  block: () =>
    makeNumberRenderer({
      baseLabel: unitConverter.alternariaCumulativeRolling7Days().title(),
      render: (v) => unitConverter.alternariaCumulativeRolling7Days(v).valueAsString(),
    }),
}
